import Analytics from '@hh.ru/analytics-js';
import buttonClick, {
    HhtmFromLabel,
} from '@hh.ru/analytics-js-events/build/xhh/applicant/hhpro/activate_hhpro_button_click';
import { translation, formatToReactComponent, TranslatedComponent } from '@hh.ru/front-static-app';
import { Button } from '@hh.ru/magritte-ui';
import { HhProSolidSize24 } from '@hh.ru/magritte-ui/service';

import FormatMoney from 'src/components/FormatMoney';
import { CurrencyType } from 'src/components/FormatMoney/CurrencyType';
import { FormState } from 'src/types/HhProFormState';

import styles from './styles.less';

const TrlKeys = {
    apply: 'hhpro.promo.apply',
    applyPrice: 'hhpro.promo.apply.price',
};

const PayButton: TranslatedComponent<{
    price: number;
    currency: CurrencyType;
    tariffId: string;
    stretched?: boolean;
    initPayment: () => void;
    formState: FormState;
    label: HhtmFromLabel;
}> = ({ currency, price, stretched, formState, tariffId, label, initPayment, trls }) => {
    const buttonText = formatToReactComponent(trls[TrlKeys.applyPrice], {
        '{price}': <FormatMoney currency={currency}>{price}</FormatMoney>,
    });
    return (
        <Button
            loading={formState === FormState.FetchingInitPayment}
            onClick={() => {
                Analytics.sendEvent('hhpro', 'applicant_connect');
                buttonClick({ tariffId, hhtmFromLabel: label });
                initPayment();
            }}
            mode="primary"
            style="contrast"
            size="large"
            stretched={stretched}
            data-qa="hhpro-payment-button"
        >
            <div className={styles.buttonInner}>
                {trls[TrlKeys.apply]}
                <HhProSolidSize24 />
                {buttonText}
            </div>
        </Button>
    );
};

export default translation(PayButton);
